import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTools } from 'react-icons/fa';
import tools from '../data/tools';
import { ProjectCard, ProjectModal } from './Projects';
import './Projects.css';
import './Tools.css';

const Tools = ({ t, language }) => {
  const [selectedTool, setSelectedTool] = useState(null);

  if (tools.length === 0) return null;

  return (
    <section className="tools" id="tools">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title neon-text">
            <FaTools className="tools-title-icon" /> {t.tools.title}
          </h2>
          <p className="projects-subtitle">{t.tools.subtitle}</p>

          <div className="projects-grid tools-grid">
            {tools.map((tool, index) => (
              <ProjectCard
                key={tool.id}
                project={tool}
                language={language}
                t={t}
                onClick={() => setSelectedTool(tool)}
                index={index}
                featured={false}
                className="tool-card"
              />
            ))}
          </div>
        </motion.div>
      </div>

      <AnimatePresence>
        {selectedTool && (
          <ProjectModal
            project={selectedTool}
            language={language}
            t={t}
            onClose={() => setSelectedTool(null)}
          />
        )}
      </AnimatePresence>
    </section>
  );
};

export default Tools;
